import { gsap } from 'gsap'

export class Accordion {
  constructor() {
    const accordions = document.querySelectorAll('.js-accordion')
    if (accordions.length === 0) return

    const duration = 0.4

    accordions.forEach((accordion) => {
      const trigger = accordion.querySelector('.js-accordion-trigger')
      const content = accordion.querySelector('.js-accordion-content')

      const wrapper = document.createElement('div')
      wrapper.classList.add('js-accordion-wrapper')
      content.parentNode.insertBefore(wrapper, content)
      wrapper.appendChild(content)

      if (accordion.classList.contains('is-open')) {
        this.animation(wrapper, 0, 'open')
      }

      trigger.addEventListener('click', () => {
        this.toggleAccordion(accordion, wrapper, duration)
      })

      // js-accordion-closeボタンを選択し、クリックイベントを追加する
      const closeButton = accordion.querySelector('.js-accordion-close')
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          this.closeAccordion(accordion, wrapper, duration)
        })
      }
    })
  }

  toggleAccordion(accordion, wrapper, duration) {
    accordion.classList.toggle('is-open')
    if (accordion.classList.contains('is-open')) {
      accordion.classList.remove('is-close')
      this.animation(wrapper, duration, 'open')
    } else {
      accordion.classList.add('is-close')
      this.animation(wrapper, duration, 'close')
    }
  }

  closeAccordion(accordion, wrapper, duration) {
    if (accordion.classList.contains('is-open')) {
      accordion.classList.remove('is-open')
      accordion.classList.add('is-close')

      this.animation(wrapper, duration, 'close')
    }
  }

  animation(el, duration, type) {
    if (type === 'open') {
      gsap.to(el, { height: 'auto', duration })
    } else {
      gsap.to(el, { height: 0, duration })
    }
  }
}
